var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_5709)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 64,
    fill: "#F4F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0205 73.9062C38.6024 73.9062 17.958 94.5088 17.958 119.969V134.625H110.041V119.969C110.041 94.5088 89.4386 73.9062 64.0205 73.9062Z",
    fill: "url(#paint0_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0205 73.9062C38.6024 73.9062 17.958 94.5088 17.958 119.969V134.625H110.041V119.969C110.041 94.5088 89.4386 73.9062 64.0205 73.9062Z",
    fill: "url(#paint1_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8564 84.8896V134.625H110.041V119.969C110.041 105.912 103.76 93.3352 93.8564 84.8896Z",
    fill: "url(#paint2_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8564 84.8896V134.625H110.041V119.969C110.041 105.912 103.76 93.3352 93.8564 84.8896Z",
    fill: "url(#paint3_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1848 134.629V84.8779C24.2589 93.3235 17.958 105.907 17.958 119.972V134.629H34.1848Z",
    fill: "url(#paint4_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1848 134.629V84.8779C24.2589 93.3235 17.958 105.907 17.958 119.972V134.629H34.1848Z",
    fill: "url(#paint5_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1848 134.629V84.8779C24.2589 93.3235 17.958 105.907 17.958 119.972V134.629H34.1848Z",
    fill: "url(#paint6_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3263 76.4668H52.6719V134.631H75.3263V76.4668Z",
    fill: "url(#paint7_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3263 76.4668H52.6719V134.631H75.3263V76.4668Z",
    fill: "url(#paint8_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3263 76.4668H52.6719V134.631H75.3263V76.4668Z",
    fill: "url(#paint9_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3263 76.4668H52.6719V134.631H75.3263V76.4668Z",
    fill: "url(#paint10_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0203 73.2676H53.4863V93.1163C53.4863 94.4144 54.8857 95.1682 55.8575 94.3307L64.0203 87.3376L72.1832 94.3307C73.155 95.1682 74.5544 94.4144 74.5544 93.1163V73.2676H64.0203Z",
    fill: "#8F809C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.9799 97.1221C61.4627 97.1221 61.023 97.4997 60.945 98.0109L55.3545 134.628H72.607L67.0366 98.0115C66.9588 97.5 66.519 97.1221 66.0016 97.1221H61.9799Z",
    fill: "url(#paint11_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5793 77.9385C48.6506 78.4273 49.0564 78.3492 47.233 79.0728C44.9681 82.3525 40.7564 88.2791 39.4824 91.1023C39.1055 91.898 39.6918 92.8192 40.5712 92.8192L45.5105 92.0899C46.5155 92.0899 46.9761 93.3042 46.3062 93.9742L40.5712 98.9843C39.4824 100.073 39.0637 101.706 39.608 103.172L51.7249 129.695L50.5793 77.9385Z",
    fill: "#44375D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6716 75.3213C50.7429 75.8101 48.8627 76.4205 47.0393 77.1441C46.9903 77.176 46.9414 77.2018 46.8928 77.2208L41.5747 88.4851C41.1978 89.2808 41.7841 90.202 42.6634 90.202H47.0603C48.0653 90.202 48.5259 91.4164 47.856 92.0864L42.161 97.6558C41.0722 98.7445 40.6535 100.378 41.1978 101.843L52.6297 134.59H52.6716V75.3213Z",
    fill: "url(#paint12_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6716 75.3213C50.7429 75.8101 48.8627 76.4205 47.0393 77.1441C46.9903 77.176 46.9414 77.2018 46.8928 77.2208L41.5747 88.4851C41.1978 89.2808 41.7841 90.202 42.6634 90.202H47.0603C48.0653 90.202 48.5259 91.4164 47.856 92.0864L42.161 97.6558C41.0722 98.7445 40.6535 100.378 41.1978 101.843L52.6297 134.59H52.6716V75.3213Z",
    fill: "url(#paint13_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6716 75.3213C50.7429 75.8101 48.8627 76.4205 47.0393 77.1441C46.9903 77.176 46.9414 77.2018 46.8928 77.2208L41.5747 88.4851C41.1978 89.2808 41.7841 90.202 42.6634 90.202H47.0603C48.0653 90.202 48.5259 91.4164 47.856 92.0864L42.161 97.6558C41.0722 98.7445 40.6535 100.378 41.1978 101.843L52.6297 134.59H52.6716V75.3213Z",
    fill: "url(#paint14_radial_107_5709)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.6716 75.3213C50.7429 75.8101 48.8627 76.4205 47.0393 77.1441C46.9903 77.176 46.9414 77.2018 46.8928 77.2208L41.5747 88.4851C41.1978 89.2808 41.7841 90.202 42.6634 90.202H47.0603C48.0653 90.202 48.5259 91.4164 47.856 92.0864L42.161 97.6558C41.0722 98.7445 40.6535 100.378 41.1978 101.843L52.6297 134.59H52.6716V75.3213Z",
    fill: "url(#paint15_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.9791 94.7591L82.8366 99.1534C83.6826 100.242 83.9754 101.875 83.585 103.383L78.1593 122.839L77.2373 79.0979L77.6173 78.3311C79.0335 78.8148 80.4152 79.4076 81.7567 80.1021L85.8598 91.1579C86.1526 91.9535 85.6971 92.8748 85.0138 92.8748H81.5973C80.8165 92.8748 80.426 94.0473 80.9791 94.7591Z",
    fill: "#44375D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.1847 91.8724L85.8797 97.4418C86.9685 98.5306 87.3454 100.164 86.8429 101.671L75.3691 134.585V76.2112L75.8581 75.4443C77.6808 75.9281 79.459 76.5209 81.1854 77.2154L86.466 88.2712C86.8429 89.0668 86.2567 89.9881 85.3773 89.9881H80.9804C79.9754 89.9881 79.4729 91.1606 80.1847 91.8724Z",
    fill: "url(#paint16_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1847 91.8724L85.8797 97.4418C86.9685 98.5306 87.3454 100.164 86.8429 101.671L75.3691 134.585V76.2112L75.8581 75.4443C77.6808 75.9281 79.459 76.5209 81.1854 77.2154L86.466 88.2712C86.8429 89.0668 86.2567 89.9881 85.3773 89.9881H80.9804C79.9754 89.9881 79.4729 91.1606 80.1847 91.8724Z",
    fill: "url(#paint17_radial_107_5709)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.02 73.002H52.6719V92.8507C52.6719 94.1488 54.1794 94.9026 55.2262 94.0651L64.02 87.0719L72.8137 94.0651C73.8606 94.9026 75.3681 94.1488 75.3681 92.8507V73.002H64.02Z",
    fill: "url(#paint18_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.02 73.002H52.6719V92.8507C52.6719 94.1488 54.1794 94.9026 55.2262 94.0651L64.02 87.0719L72.8137 94.0651C73.8606 94.9026 75.3681 94.1488 75.3681 92.8507V73.002H64.02Z",
    fill: "url(#paint19_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.02 73.002H52.6719V92.8507C52.6719 94.1488 54.1794 94.9026 55.2262 94.0651L64.02 87.0719L72.8137 94.0651C73.8606 94.9026 75.3681 94.1488 75.3681 92.8507V73.002H64.02Z",
    fill: "url(#paint20_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.02 73.002H52.6719V92.8507C52.6719 94.1488 54.1794 94.9026 55.2262 94.0651L64.02 87.0719L72.8137 94.0651C73.8606 94.9026 75.3681 94.1488 75.3681 92.8507V73.002H64.02Z",
    fill: "url(#paint21_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6885 91.3308L63.9942 86.7344L69.3044 91.2327L67.0181 96.5304C66.8545 96.8908 66.5011 97.1213 66.1125 97.1213H61.8352C61.4465 97.1213 61.0932 96.8908 60.9295 96.5304L58.6885 91.3308Z",
    fill: "url(#paint22_linear_107_5709)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.0233 86.241C71.515 82.9423 72.1133 80.7304 72.0591 79.125H55.9874C55.9332 80.7304 56.9242 83.1876 64.0233 86.241Z",
    fill: "url(#paint23_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.3456 92.0635H91.7861C90.8663 92.0635 90.0265 92.606 89.6266 93.4407C89.5866 93.5242 89.4666 93.5242 89.4666 93.4407C89.0667 92.606 88.2268 92.0635 87.307 92.0635H84.8275C84.3076 92.0635 83.8677 92.4391 83.8277 92.9816C83.7877 93.5242 84.2276 94.025 84.7475 94.025H85.3874C86.1362 94.025 86.1363 94.3573 86.2775 94.652C86.5175 95.1528 86.9974 95.4867 87.5573 95.4867H88.5571L90.8144 96.0265C91.3743 96.0265 92.7459 95.6109 92.9859 95.11L93.3458 94.2754C93.4258 94.1084 93.5858 94.025 93.7457 94.025H94.3456C94.8655 94.025 95.3054 93.6494 95.3454 93.1068C95.3054 92.5225 94.8655 92.0635 94.3456 92.0635Z",
    fill: "#473A60"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ii_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.841 91.834H92.161C91.1978 91.834 90.3185 92.3784 89.8997 93.2159C89.8578 93.2996 89.7322 93.2996 89.7322 93.2159C89.3135 92.3784 88.4341 91.834 87.471 91.834H84.8747C84.3303 91.834 83.8697 92.2109 83.8278 92.7552C83.786 93.2996 84.2466 93.8021 84.791 93.8021H85.461C85.6285 93.8021 85.796 93.8859 85.8797 94.0534L86.2566 94.8909C86.5078 95.3934 87.0103 95.7284 87.5966 95.7284H88.6435H91.0303H92.0772C92.6635 95.7284 93.166 95.3934 93.4172 94.8909L93.7941 94.0534C93.8778 93.8859 94.0453 93.8021 94.2128 93.8021H94.841C95.3853 93.8021 95.846 93.4252 95.8878 92.8809C95.846 92.2946 95.3853 91.834 94.841 91.834Z",
    fill: "url(#paint24_linear_107_5709)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.7121 59.6553C86.1158 59.6099 87.4305 59.1339 88.5 58.3633V62.2619C88.5 66.0018 86.2718 69.3337 82.885 70.7164C83.598 69.1977 84.0882 67.5431 84.3333 65.7751L84.7121 59.6553Z",
    fill: "url(#paint25_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7121 59.6553C86.1158 59.6099 87.4305 59.1339 88.5 58.3633V62.2619C88.5 66.0018 86.2718 69.3337 82.885 70.7164C83.598 69.1977 84.0882 67.5431 84.3333 65.7751L84.7121 59.6553Z",
    fill: "url(#paint26_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0008 59.6553C42.5971 59.6099 41.2824 59.1339 40.2129 58.3633V62.2619C40.2129 66.0018 42.4411 69.3337 45.8279 70.7164C45.1149 69.1977 44.6247 67.5431 44.3796 65.7751L44.0008 59.6553Z",
    fill: "url(#paint27_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0008 59.6553C42.5971 59.6099 41.2824 59.1339 40.2129 58.3633V62.2619C40.2129 66.0018 42.4411 69.3337 45.8279 70.7164C45.1149 69.1977 44.6247 67.5431 44.3796 65.7751L44.0008 59.6553Z",
    fill: "url(#paint28_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.3711,
    y: 35.458,
    width: 3.01279,
    height: 15.7096,
    fill: "url(#paint29_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.4854,
    y: 35.458,
    width: 3.01279,
    height: 15.7096,
    fill: "url(#paint30_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ii_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1501 65.9977C45.2274 74.1732 52.1848 80.2599 60.4215 80.2599H68.3215C76.5582 80.2599 83.5156 74.1732 84.5929 65.9977C85.0869 58.1097 85.5837 50.2534 85.9502 42.3696C85.9058 39.1578 83.3739 36.5075 80.1757 36.3728H74.3124C70.3147 36.3728 66.6945 34.0145 65.051 30.331C64.629 29.2754 63.6074 28.5791 62.4747 28.5791H57.1444C49.4154 28.5791 43.1523 34.9128 43.1523 42.729C43.1523 50.5207 43.639 58.1863 44.1501 65.9977Z",
    fill: "url(#paint31_radial_107_5709)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.1501 65.9977C45.2274 74.1732 52.1848 80.2599 60.4215 80.2599H68.3215C76.5582 80.2599 83.5156 74.1732 84.5929 65.9977C85.0869 58.1097 85.5837 50.2534 85.9502 42.3696C85.9058 39.1578 83.3739 36.5075 80.1757 36.3728H74.3124C70.3147 36.3728 66.6945 34.0145 65.051 30.331C64.629 29.2754 63.6074 28.5791 62.4747 28.5791H57.1444C49.4154 28.5791 43.1523 34.9128 43.1523 42.729C43.1523 50.5207 43.639 58.1863 44.1501 65.9977Z",
    fill: "url(#paint32_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1501 65.9977C45.2274 74.1732 52.1848 80.2599 60.4215 80.2599H68.3215C76.5582 80.2599 83.5156 74.1732 84.5929 65.9977C85.0869 58.1097 85.5837 50.2534 85.9502 42.3696C85.9058 39.1578 83.3739 36.5075 80.1757 36.3728H74.3124C70.3147 36.3728 66.6945 34.0145 65.051 30.331C64.629 29.2754 63.6074 28.5791 62.4747 28.5791H57.1444C49.4154 28.5791 43.1523 34.9128 43.1523 42.729C43.1523 50.5207 43.639 58.1863 44.1501 65.9977Z",
    fill: "url(#paint33_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1501 65.9977C45.2274 74.1732 52.1848 80.2599 60.4215 80.2599H68.3215C76.5582 80.2599 83.5156 74.1732 84.5929 65.9977C85.0869 58.1097 85.5837 50.2534 85.9502 42.3696C85.9058 39.1578 83.3739 36.5075 80.1757 36.3728H74.3124C70.3147 36.3728 66.6945 34.0145 65.051 30.331C64.629 29.2754 63.6074 28.5791 62.4747 28.5791H57.1444C49.4154 28.5791 43.1523 34.9128 43.1523 42.729C43.1523 50.5207 43.639 58.1863 44.1501 65.9977Z",
    fill: "url(#paint34_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1501 65.9977C45.2274 74.1732 52.1848 80.2599 60.4215 80.2599H68.3215C76.5582 80.2599 83.5156 74.1732 84.5929 65.9977C85.0869 58.1097 85.5837 50.2534 85.9502 42.3696C85.9058 39.1578 83.3739 36.5075 80.1757 36.3728H74.3124C70.3147 36.3728 66.6945 34.0145 65.051 30.331C64.629 29.2754 63.6074 28.5791 62.4747 28.5791H57.1444C49.4154 28.5791 43.1523 34.9128 43.1523 42.729C43.1523 50.5207 43.639 58.1863 44.1501 65.9977Z",
    fill: "url(#paint35_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1501 65.9977C45.2274 74.1732 52.1848 80.2599 60.4215 80.2599H68.3215C76.5582 80.2599 83.5156 74.1732 84.5929 65.9977C85.0869 58.1097 85.5837 50.2534 85.9502 42.3696C85.9058 39.1578 83.3739 36.5075 80.1757 36.3728H74.3124C70.3147 36.3728 66.6945 34.0145 65.051 30.331C64.629 29.2754 63.6074 28.5791 62.4747 28.5791H57.1444C49.4154 28.5791 43.1523 34.9128 43.1523 42.729C43.1523 50.5207 43.639 58.1863 44.1501 65.9977Z",
    fill: "url(#paint36_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3224 52.2487L59.6635 59.9468C59.2093 61.5302 60.2994 63.1137 61.8437 63.1137H65.1365C66.6808 63.1137 67.7709 61.5059 67.3167 59.9468L65.0911 52.2487C64.6142 50.5434 62.822 50.5434 62.3224 52.2487Z",
    fill: "#EE9020"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7553 51.4254L60.5297 59.1235C60.0755 60.707 61.1656 62.2905 62.7099 62.2905H66.0028C67.547 62.2905 68.6371 60.6826 68.1829 59.1235L65.9573 51.4254C65.4804 49.7202 63.2549 49.7202 62.7553 51.4254Z",
    fill: "url(#paint37_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7553 51.4254L60.5297 59.1235C60.0755 60.707 61.1656 62.2905 62.7099 62.2905H66.0028C67.547 62.2905 68.6371 60.6826 68.1829 59.1235L65.9573 51.4254C65.4804 49.7202 63.2549 49.7202 62.7553 51.4254Z",
    fill: "url(#paint38_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7553 51.4254L60.5297 59.1235C60.0755 60.707 61.1656 62.2905 62.7099 62.2905H66.0028C67.547 62.2905 68.6371 60.6826 68.1829 59.1235L65.9573 51.4254C65.4804 49.7202 63.2549 49.7202 62.7553 51.4254Z",
    fill: "url(#paint39_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7553 51.4254L60.5297 59.1235C60.0755 60.707 61.1656 62.2905 62.7099 62.2905H66.0028C67.547 62.2905 68.6371 60.6826 68.1829 59.1235L65.9573 51.4254C65.4804 49.7202 63.2549 49.7202 62.7553 51.4254Z",
    fill: "url(#paint40_linear_107_5709)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6989 64.8935L58.6989 64.8934L58.6961 64.892C58.2694 64.675 57.8244 64.8112 57.561 65.0885C57.2961 65.3673 57.1882 65.8211 57.4646 66.2229C58.9239 68.4324 61.464 69.9037 64.3552 69.9037C67.2474 69.9037 69.7882 68.4314 71.2473 66.2208C71.5187 65.8131 71.4185 65.3599 71.148 65.0791C70.8814 64.8023 70.4366 64.6773 70.0144 64.892L70.0144 64.892L70.0116 64.8935C68.379 65.7446 66.4526 66.2332 64.3552 66.2332C62.2788 66.2332 60.3313 65.7444 58.6989 64.8935Z",
    stroke: "url(#paint41_radial_107_5709)",
    strokeWidth: 0.628125
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.3552 66.5473C62.2301 66.5473 60.2325 66.0472 58.5537 65.1719C57.9799 64.8802 57.3637 65.5262 57.7249 66.0472C59.1275 68.1727 61.5714 69.5897 64.3552 69.5897C67.1391 69.5897 69.583 68.1727 70.9855 66.0472C71.3468 65.5054 70.7305 64.8802 70.1568 65.1719C68.4779 66.0472 66.5016 66.5473 64.3552 66.5473Z",
    fill: "url(#paint42_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3693 47.4482C77.1042 47.4482 79.4145 49.3338 80.043 51.8818C80.2298 52.6123 79.6693 53.3088 78.9218 53.3088H69.579C68.9844 53.3088 68.5088 52.7652 68.6277 52.1706C69.1543 49.4867 71.5155 47.4482 74.3693 47.4482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5032 48.585C75.5756 48.585 77.2403 50.2667 77.2403 52.3221C77.2403 52.6618 77.1893 53.0016 77.1044 53.3073H69.8849C69.8 52.9846 69.749 52.6618 69.749 52.3221C69.749 50.2667 71.4307 48.585 73.5032 48.585Z",
    fill: "url(#paint43_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3604 52.32C71.3604 51.131 72.3116 50.1797 73.5007 50.1797C74.6898 50.1797 75.6411 51.131 75.6411 52.32C75.6411 52.6768 75.5561 53.0165 75.4033 53.3053H71.6152C71.4453 53.0165 71.3604 52.6768 71.3604 52.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.2268 49.3729C73.493 49.729 72.9365 50.1631 72.3037 50.6362C71.6709 51.1094 71.2015 51.4423 70.9352 51.0862C70.669 50.7301 70.9661 50.0579 71.5989 49.5847C72.2317 49.1116 72.9605 49.0168 73.2268 49.3729Z",
    fill: "#C7A7A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2268 49.3729C73.493 49.729 72.9365 50.1631 72.3037 50.6362C71.6709 51.1094 71.2015 51.4423 70.9352 51.0862C70.669 50.7301 70.9661 50.0579 71.5989 49.5847C72.2317 49.1116 72.9605 49.0168 73.2268 49.3729Z",
    fill: "url(#paint44_radial_107_5709)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.8285 51.8311C76.6905 50.865 76.1251 50.1369 75.8597 49.8936L74.7715 51.088L75.2625 52.0435L76.8285 51.8311Z",
    fill: "url(#paint45_linear_107_5709)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.343 47.4482C51.6079 47.4482 49.2976 49.3339 48.669 51.8821C48.4822 52.6126 49.0428 53.3091 49.7902 53.3091H59.1336C59.7281 53.3091 60.2038 52.7654 60.0849 52.1709C59.5583 49.4868 57.18 47.4482 54.343 47.4482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.211 48.585C53.1384 48.585 51.4736 50.2668 51.4736 52.3223C51.4736 52.662 51.5246 53.0018 51.6095 53.3076H58.8294C58.9143 52.9848 58.9653 52.662 58.9653 52.3223C58.9483 50.2668 57.2835 48.585 55.211 48.585Z",
    fill: "url(#paint46_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3503 52.3202C57.3503 51.131 56.399 50.1797 55.2098 50.1797C54.0207 50.1797 53.0693 51.131 53.0693 52.3202C53.0693 52.6769 53.1543 53.0167 53.3072 53.3055H57.0955C57.2484 53.0167 57.3503 52.6769 57.3503 52.3202Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6242 51.8841C58.6242 50.6764 57.6421 49.8712 57.3767 49.6279L56.1689 50.7958L56.9122 52.3088L58.6242 51.8841Z",
    fill: "url(#paint47_linear_107_5709)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_107_5709)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.0832,
    cy: 50.1826,
    rx: 1.63154,
    ry: 0.825712,
    transform: "rotate(-27.914 54.0832 50.1826)",
    fill: "#C7A7A3",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.0832,
    cy: 50.1826,
    rx: 1.63154,
    ry: 0.825712,
    transform: "rotate(-27.914 54.0832 50.1826)",
    fill: "url(#paint48_radial_107_5709)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.9668 60.0354C85.2423 55.5791 85.508 51.1282 85.7397 46.6719C88.9037 47.2255 91.3085 49.9863 91.3085 53.3088C91.3085 56.8971 88.5036 59.8302 84.9668 60.0354Z",
    fill: "url(#paint49_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9668 60.0354C85.2423 55.5791 85.508 51.1282 85.7397 46.6719C88.9037 47.2255 91.3085 49.9863 91.3085 53.3088C91.3085 56.8971 88.5036 59.8302 84.9668 60.0354Z",
    fill: "url(#paint50_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9668 60.0354C85.2423 55.5791 85.508 51.1282 85.7397 46.6719C88.9037 47.2255 91.3085 49.9863 91.3085 53.3088C91.3085 56.8971 88.5036 59.8302 84.9668 60.0354Z",
    fill: "url(#paint51_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1921 46.6377C39.9203 47.099 37.4033 49.9103 37.4033 53.3094C37.4033 56.9067 40.2224 59.8457 43.7719 60.0375C43.5016 55.5629 43.2787 51.1137 43.1921 46.6377Z",
    fill: "url(#paint52_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1921 46.6377C39.9203 47.099 37.4033 49.9103 37.4033 53.3094C37.4033 56.9067 40.2224 59.8457 43.7719 60.0375C43.5016 55.5629 43.2787 51.1137 43.1921 46.6377Z",
    fill: "url(#paint53_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2643 49.4033C41.4776 49.8039 40.1426 51.3996 40.1426 53.3071C40.1426 55.3371 41.6544 57.014 43.6136 57.2731C43.4684 54.6483 43.346 52.0286 43.2643 49.4033Z",
    fill: "#DD8224"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.1338 57.3072C85.2952 54.6501 85.4513 51.9941 85.597 49.3369C87.5704 49.5831 89.0974 51.2665 89.0974 53.3066C89.0974 55.5038 87.3262 57.2872 85.1338 57.3072Z",
    fill: "#FFC837"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.062 23.868C76.9233 16.9168 64.1933 17.3774 64.0258 17.3774C63.8583 17.3774 50.877 17.3355 39.9895 23.8262C35.802 26.3387 35.0064 32.0337 38.3564 35.5512L41.2039 38.5662H63.9839H64.0677H86.8477L89.6952 35.5512C93.0452 32.0755 92.2077 26.4224 88.062 23.868Z",
    fill: "url(#paint54_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.062 23.868C76.9233 16.9168 64.1933 17.3774 64.0258 17.3774C63.8583 17.3774 50.877 17.3355 39.9895 23.8262C35.802 26.3387 35.0064 32.0337 38.3564 35.5512L41.2039 38.5662H63.9839H64.0677H86.8477L89.6952 35.5512C93.0452 32.0755 92.2077 26.4224 88.062 23.868Z",
    fill: "url(#paint55_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.062 23.868C76.9233 16.9168 64.1933 17.3774 64.0258 17.3774C63.8583 17.3774 50.877 17.3355 39.9895 23.8262C35.802 26.3387 35.0064 32.0337 38.3564 35.5512L41.2039 38.5662H63.9839H64.0677H86.8477L89.6952 35.5512C93.0452 32.0755 92.2077 26.4224 88.062 23.868Z",
    fill: "url(#paint56_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0201 35.5085C64.0201 35.5085 53.4257 35.3829 41.1982 38.5654L42.8732 40.5335C45.9301 44.1766 50.4526 46.2704 55.2264 46.2704H72.772C77.5457 46.2704 82.0682 44.1766 85.167 40.5335L86.842 38.5654C74.6145 35.3829 64.0201 35.5085 64.0201 35.5085Z",
    fill: "url(#paint57_radial_107_5709)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.8107 32.1172H64.2295C65.8626 32.1172 73.7351 32.2009 83.3245 34.2528C85.3764 34.6716 86.842 36.4722 86.842 38.5659C74.6145 35.3833 64.0201 35.509 64.0201 35.509C64.0201 35.509 53.4257 35.3833 41.1982 38.5659C41.1982 36.4722 42.6639 34.6716 44.7157 34.2528C54.3051 32.2428 62.1357 32.1172 63.8107 32.1172Z",
    fill: "url(#paint58_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8107 32.1172H64.2295C65.8626 32.1172 73.7351 32.2009 83.3245 34.2528C85.3764 34.6716 86.842 36.4722 86.842 38.5659C74.6145 35.3833 64.0201 35.509 64.0201 35.509C64.0201 35.509 53.4257 35.3833 41.1982 38.5659C41.1982 36.4722 42.6639 34.6716 44.7157 34.2528C54.3051 32.2428 62.1357 32.1172 63.8107 32.1172Z",
    fill: "url(#paint59_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8107 32.1172H64.2295C65.8626 32.1172 73.7351 32.2009 83.3245 34.2528C85.3764 34.6716 86.842 36.4722 86.842 38.5659C74.6145 35.3833 64.0201 35.509 64.0201 35.509C64.0201 35.509 53.4257 35.3833 41.1982 38.5659C41.1982 36.4722 42.6639 34.6716 44.7157 34.2528C54.3051 32.2428 62.1357 32.1172 63.8107 32.1172Z",
    fill: "url(#paint60_radial_107_5709)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.3225 27.224H69.9741C70.3091 27.224 70.5603 27.0565 70.7278 26.7634L73.031 22.7852C73.1985 22.4921 72.9891 22.1152 72.6541 22.1152H66.7916C66.4566 22.1152 66.2053 22.2827 66.0378 22.5759L64.8865 24.5646C64.622 24.4965 64.3447 24.4602 64.0589 24.4602C63.7428 24.4602 63.437 24.5046 63.1475 24.5874L62.0072 22.6177C61.8396 22.3246 61.5884 22.1571 61.2534 22.1571H55.3909C55.0559 22.1571 54.8465 22.534 55.014 22.8271L57.2753 26.7634C57.4427 27.0565 57.694 27.224 58.0291 27.224H60.7954C60.7661 27.4011 60.7508 27.5829 60.7508 27.7684C60.7508 29.5954 62.232 31.0765 64.0589 31.0765C65.886 31.0765 67.3671 29.5954 67.3671 27.7684C67.3671 27.5829 67.3518 27.4011 67.3225 27.224Z",
    fill: "#382534"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_i_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.1894 26.7602H58.3269C57.9919 26.7602 57.7406 26.5927 57.5731 26.2996L55.3119 22.3634C55.1444 22.0702 55.3538 21.6934 55.6888 21.6934H61.5513C61.8863 21.6934 62.1375 21.8609 62.305 22.154L64.6081 26.1321C64.7338 26.3834 64.5244 26.7602 64.1894 26.7602Z",
    fill: "url(#paint61_linear_107_5709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1894 26.7602H58.3269C57.9919 26.7602 57.7406 26.5927 57.5731 26.2996L55.3119 22.3634C55.1444 22.0702 55.3538 21.6934 55.6888 21.6934H61.5513C61.8863 21.6934 62.1375 21.8609 62.305 22.154L64.6081 26.1321C64.7338 26.3834 64.5244 26.7602 64.1894 26.7602Z",
    fill: "url(#paint62_radial_107_5709)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_i_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.4065 26.7572H70.269C70.604 26.7572 70.8553 26.5897 71.0228 26.2966L73.3259 22.3184C73.4934 22.0253 73.284 21.6484 72.949 21.6484H67.0865C66.7515 21.6484 66.5003 21.8159 66.3328 22.1091L64.0297 26.0872C63.8622 26.3803 64.0715 26.7572 64.4065 26.7572Z",
    fill: "url(#paint63_linear_107_5709)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_i_107_5709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.355 30.6084C66.182 30.6084 67.6631 29.1273 67.6631 27.3003C67.6631 25.4733 66.182 23.9922 64.355 23.9922C62.528 23.9922 61.0469 25.4733 61.0469 27.3003C61.0469 29.1273 62.528 30.6084 64.355 30.6084Z",
    fill: "url(#paint64_radial_107_5709)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.355 30.6084C66.182 30.6084 67.6631 29.1273 67.6631 27.3003C67.6631 25.4733 66.182 23.9922 64.355 23.9922C62.528 23.9922 61.0469 25.4733 61.0469 27.3003C61.0469 29.1273 62.528 30.6084 64.355 30.6084Z",
    fill: "url(#paint65_radial_107_5709)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_107_5709",
    x: 49.2988,
    y: 69.0801,
    width: 29.4434,
    height: 29.791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.09375,
    result: "effect1_foregroundBlur_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_107_5709",
    x: 35.1787,
    y: 73.751,
    width: 20.7334,
    height: 60.1313,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.09375,
    result: "effect1_foregroundBlur_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_107_5709",
    x: 40.3318,
    y: 75.3213,
    width: 12.9682,
    height: 59.8962,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.628125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.523438
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.356863 0 0 0 0 0.470588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_107_5709"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.628125,
    dy: 0.628125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.523438
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.34902 0 0 0 0 0.290196 0 0 0 0 0.443137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_107_5709",
    result: "effect2_innerShadow_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_107_5709",
    x: 73.0498,
    y: 74.1436,
    width: 17.0879,
    height: 52.8828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.09375,
    result: "effect1_foregroundBlur_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_107_5709",
    x: 74.3223,
    y: 75.4443,
    width: 12.7402,
    height: 59.1406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.04688
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.04688
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.372549 0 0 0 0 0.541176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_107_5709"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.41875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.41875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.34902 0 0 0 0 0.552941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_107_5709",
    result: "effect2_innerShadow_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_107_5709",
    x: 58.2697,
    y: 86.3156,
    width: 11.4537,
    height: 10.8055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.41875,
    dy: -0.41875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.04688
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.152941 0 0 0 0 0.25098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_107_5709"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.41875,
    dy: -0.41875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.04688
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.152941 0 0 0 0 0.25098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_107_5709",
    result: "effect2_innerShadow_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_107_5709",
    x: 82.9877,
    y: 91.226,
    width: 13.1955,
    height: 5.63789,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.41875,
    result: "effect1_foregroundBlur_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii_107_5709",
    x: 83.8252,
    y: 91.6246,
    width: 12.0625,
    height: 4.31328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.209375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.209375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.823529 0 0 0 0 0.529412 0 0 0 0 0.192157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_107_5709"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.209375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.209375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.760784 0 0 0 0 0.313726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_107_5709",
    result: "effect2_innerShadow_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ii_107_5709",
    x: 43.1523,
    y: 28.5791,
    width: 44.8916,
    height: 52.5182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.09375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.09375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.823529 0 0 0 0 0.623529 0 0 0 0 0.313726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_107_5709"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57031
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.54902 0 0 0 0 0.0941176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_107_5709",
    result: "effect2_innerShadow_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_107_5709",
    x: 55.3721,
    y: 46.7822,
    width: 16.2363,
    height: 20.519,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.09375,
    result: "effect1_foregroundBlur_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_107_5709",
    x: 60.007,
    y: 49.7277,
    width: 8.69883,
    height: 12.9815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.209375,
    result: "effect1_foregroundBlur_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_107_5709",
    x: 56.5695,
    y: 64.0505,
    width: 15.5709,
    height: 6.58604,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.209375,
    result: "effect1_foregroundBlur_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_107_5709",
    x: 70.4191,
    y: 48.7385,
    width: 3.29453,
    height: 2.91562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.209375,
    result: "effect1_foregroundBlur_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_107_5709",
    x: 73.934,
    y: 49.0561,
    width: 3.73164,
    height: 3.8249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.41875,
    result: "effect1_foregroundBlur_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_107_5709",
    x: 55.3314,
    y: 48.7904,
    width: 4.13008,
    height: 4.35566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.41875,
    result: "effect1_foregroundBlur_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_107_5709",
    x: 52.1711,
    y: 48.7077,
    width: 3.82383,
    height: 2.9498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.209375,
    result: "effect1_foregroundBlur_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_107_5709",
    x: 39.0957,
    y: 48.3564,
    width: 5.56445,
    height: 9.96338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.523438,
    result: "effect1_foregroundBlur_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_107_5709",
    x: 84.0869,
    y: 48.29,
    width: 6.05762,
    height: 10.064,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.523438,
    result: "effect1_foregroundBlur_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_107_5709",
    x: 41.1982,
    y: 34.6703,
    width: 45.6436,
    height: 11.6002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.8375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.41875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.286275 0 0 0 0 0.168627 0 0 0 0 0.34902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_107_5709",
    x: 53.9082,
    y: 21.0684,
    width: 20.2285,
    height: 11.0552,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.523438,
    result: "effect1_foregroundBlur_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_i_107_5709",
    x: 55.0436,
    y: 21.6934,
    width: 9.60098,
    height: 5.06689,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.209375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.209375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.905882 0 0 0 0 0.65098 0 0 0 0 0.309804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_i_107_5709",
    x: 63.7613,
    y: 21.6484,
    width: 9.62344,
    height: 5.10889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.209375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.209375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.960784 0 0 0 0 0.752941 0 0 0 0 0.317647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_107_5709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_i_107_5709",
    x: 61.0469,
    y: 23.7828,
    width: 6.82559,
    height: 6.82559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.209375,
    dy: -0.209375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.8375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.698039 0 0 0 0 0.4 0 0 0 0 0.121569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_107_5709"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_5709",
    x1: 63.9996,
    y1: 73.9062,
    x2: 63.9996,
    y2: 134.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A4B85"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.249 111.186) rotate(180) scale(16.8809 51.21)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.20155,
    stopColor: "#7D77A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B629A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.949 134.625) rotate(-90) scale(43.9337 9.05956)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239741,
    stopColor: "#7D72A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E658C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.8564 134.625) rotate(-90) scale(57.3253 3.00957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.303825,
    stopColor: "#4F4175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#514476",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.7018 134.629) rotate(-90) scale(41.655 17.7343)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.260408,
    stopColor: "#5A4B81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#524A68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_107_5709",
    x1: 35.254,
    y1: 125.486,
    x2: 26.0714,
    y2: 125.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.124232,
    stopColor: "#443A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#524C6A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4657 133.105) rotate(-180) scale(15.5077 65.7181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.740511,
    stopColor: "#6E638C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E638C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.9991 105.549) rotate(90) scale(33.1236 14.2429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.563012,
    stopColor: "#C7BBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A0B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_107_5709",
    x1: 66.1136,
    y1: 136.579,
    x2: 66.1136,
    y2: 130.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2AADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2AADC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_107_5709",
    x1: 76.8441,
    y1: 120.221,
    x2: 68.8616,
    y2: 120.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80728B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80728B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.4417 135.532) rotate(-90) scale(4.97266 1.9368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD91CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD91CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.9636 97.1221) rotate(90) scale(40.6318 6.50372)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#59416C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906602,
    stopColor: "#3A3045"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_107_5709",
    x1: 52.6716,
    y1: 131.999,
    x2: 52.6716,
    y2: 75.3213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#605388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564973"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.9905 77.0381) rotate(122.782) scale(15.098 16.9413)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#483555",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.6716 106.238) rotate(90) scale(17.1117 5.8558)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#615589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#615589",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_107_5709",
    x1: 52.6716,
    y1: 133.331,
    x2: 52.6716,
    y2: 106.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306451,
    stopColor: "#5D4F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4F84",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_107_5709",
    x1: 75.3691,
    y1: 95.8775,
    x2: 79.5934,
    y2: 95.8775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56466E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#625990"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.7145 75.4443) rotate(59.5037) scale(6.70435 8.21014)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504069",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.02 87.2611) rotate(90) scale(17.4043 20.3138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.518797,
    stopColor: "#C0AAC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#928392"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.8138 91.4283) rotate(-135.909) scale(5.83022 13.1789)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0C1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0C1D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_107_5709",
    x1: 53.8782,
    y1: 78.3423,
    x2: 60.5521,
    y2: 86.9136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68565A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#987A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_107_5709",
    x1: 74.2269,
    y1: 78.0806,
    x2: 68.5999,
    y2: 85.4087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68565A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#987A8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_107_5709",
    x1: 63.9606,
    y1: 89.5058,
    x2: 63.9606,
    y2: 96.6122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#543555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#483A53"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.0237 80.8322) rotate(90) scale(8.63672 8.03831)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B87E1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_107_5709",
    x1: 85.2915,
    y1: 93.0725,
    x2: 92.8092,
    y2: 95.7284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3AB3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAC40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.5876 58.3633) rotate(103.169) scale(16.0338 19.0469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0431525,
    stopColor: "#FFC135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E26839"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.4642 59.4863) rotate(53.9017) scale(2.08477 1.77105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E18C2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E18C2A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.1253 58.8546) rotate(71.2338) scale(17.3519 7.88722)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D57A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D06A3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.8978 58.8195) rotate(72.2903) scale(4.38394 3.84563)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.263377,
    stopColor: "#BE691E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977292,
    stopColor: "#BE691E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_107_5709",
    x1: 40.3711,
    y1: 42.027,
    x2: 43.3839,
    y2: 42.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB822A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.4981 39.4392) rotate(96.5805) scale(9.78412 3.37217)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901122,
    stopColor: "#FFC024"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.1118 54.4195) rotate(180) scale(21.8916 38.7261)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A129"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.5427 81.0913) rotate(-90) scale(12.8242 51.9046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B76E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248565,
    stopColor: "#E08935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA041",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.9503 53.4494) rotate(93.7745) scale(25.6073 9.41432)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.389903,
    stopColor: "#FFD930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD930",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.5967 49.4764) rotate(-90) scale(5.92054 7.12802)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.276316,
    stopColor: "#F59632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59632",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.7756 47.7529) rotate(-90) scale(6.42883 8.33838)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.178218,
    stopColor: "#FFBE3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.5513 42.6187) rotate(90) scale(9.16016 21.3989)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.414286,
    stopColor: "#E3822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3822D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_107_5709",
    x1: 64.3563,
    y1: 57.8883,
    x2: 67.9359,
    y2: 57.8883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC92F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_107_5709",
    x1: 59.8643,
    y1: 57.2369,
    x2: 64.362,
    y2: 57.4851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E88830",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49F22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_107_5709",
    x1: 64.3563,
    y1: 59.5581,
    x2: 64.3563,
    y2: 63.1254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E88830",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844655,
    stopColor: "#E88830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_107_5709",
    x1: 64.3563,
    y1: 50.1465,
    x2: 63.3393,
    y2: 53.0756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0A531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A531",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.6367 68.1906) rotate(-60.732) scale(2.97352 8.65305)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB534",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.3552 69.2387) rotate(-90) scale(3.01808 12.1425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89014E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87004D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.4947 50.5825) rotate(90) scale(3.3974 5.40395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#925C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85534D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.5375 50.9327) rotate(-127.812) scale(1.58408 2.1809)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_107_5709",
    x1: 76.7489,
    y1: 50.8093,
    x2: 75.435,
    y2: 51.6188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.2195 50.5826) rotate(90) scale(3.39757 5.40422)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#925C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85534D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_107_5709",
    x1: 58.3332,
    y1: 50.8091,
    x2: 57.0193,
    y2: 51.6187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.0199 51.5014) rotate(-90.897) scale(2.06923 2.4873)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_107_5709",
    x1: 91.3085,
    y1: 50.9224,
    x2: 86.2549,
    y2: 60.0354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC136"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.6931 50.6417) rotate(74.3475) scale(9.75548 9.30749)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.856273,
    stopColor: "#E1943D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08F2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.2021 52.9228) rotate(-53.9198) scale(5.60153 4.6952)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663731,
    stopColor: "#FFBD22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_107_5709",
    x1: 39.8599,
    y1: 53.8709,
    x2: 45.9663,
    y2: 53.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E39726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9851D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.3165 51.3441) rotate(101.248) scale(8.8636 8.71373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.77507,
    stopColor: "#C77937",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C77937"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.0307 17.3711) rotate(94.1768) scale(17.9668 48.1644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.266807,
    stopColor: "#5D4C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B3541"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.0893 27.0461) rotate(180) scale(19.3672 5.41142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0777028,
    stopColor: "#635870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635870",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.2734 28.8782) scale(7.3317 9.7126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5A62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3340",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.8812 46.2704) rotate(-96.6259) scale(14.7433 61.3132)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0637953,
    stopColor: "#695978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469759,
    stopColor: "#4F3E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_107_5709",
    x1: 69.6469,
    y1: 37.6456,
    x2: 43.6058,
    y2: 37.6456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3AC3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B88538"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.35 34.3741) rotate(-173.075) scale(18.7186 2.27345)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.35 38.5659) rotate(-171.342) scale(16.546 2.50599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278022,
    stopColor: "#EBA026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBA026",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_107_5709",
    x1: 64.3819,
    y1: 26.4274,
    x2: 57.7735,
    y2: 26.4274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D19B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2A23D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.5826 26.0675) rotate(-135) scale(2.6032 4.09452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.382113,
    stopColor: "#C47C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C47C25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_107_5709",
    x1: 72.7212,
    y1: 22.2696,
    x2: 66.4972,
    y2: 26.4216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6AC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E09037"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.4411 25.9324) rotate(134.061) scale(5.64518 5.85423)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8634"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_107_5709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.4967 28.0261) rotate(-36.8699) scale(4.58008 7.74688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.671429,
    stopColor: "#FCBB51",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBB51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_5709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelper);
export default __webpack_public_path__ + "static/media/helper.b2ccdfc96a217dae5cc8320e3e2532f8.svg";
export { ForwardRef as ReactComponent };